import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Login from "./Components/Pages/Login/Login";
import { AuthProvider } from "./Components/AuthContext/AuthContext";
import Addleads from "./Components/Pages/Sales-Executive/Leads/AddLeads/Addleads";
import ViewLeads from "./Components/Pages/Sales-Executive/Leads/ViewLeads/ViewLeads";


import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import ManagerDashboard from "./Components/Pages/Manager/Dashboard/Dashboard";
import SalesDashboard from "./Components/Pages/Sales-Executive/Dashboard/Dashboard";
import AdminDashboard from "./Components/Pages/Admin/Dashboard/Dashboard";
import LoginNew from "./Components/Pages/Login/LoginNew";
import Forgot from "./Components/Pages/ForgotPassword/ForgotPassword";
import ManagerCustomer from "./Components/Pages/Manager/Customer/Customer";
import AdminCustomer from "./Components/Pages/Admin/Customer/Customer";
import SalesCustomer from "./Components/Pages/Sales-Executive/Customer/Customer";



import ManagerPotentialLeads from "./Components/Pages/Manager/Potentialleads/Potentialleads";
import ManagerLeadDetails from "./Components/Pages/Manager/Potentialleads/LeadDetails";
import Potentialleads from "./Components/Pages/Sales-Executive/Potentialleads/Potentialleads";
import LeadDetails from "./Components/Pages/Sales-Executive/Potentialleads/OppDetails/LeadDetails";
import ManagerAddleads from "./Components/Pages/Manager/Leads/AddLeads/Addleads";
import MyTeam from "./Components/Pages/Manager/MyTeam/MyTeam";
import ManagerViewLeads from "./Components/Pages/Manager/Leads/ViewLeads/ViewLeads";
import ProfileForm from "./Components/Pages/Sales-Executive/Profile/Profile";
// import Service from "./Components/Pages/Admin/Service/ServiceTable/ServiceTable";
import AllTeams from "./Components/Pages/Admin/AllTeams/AllTeams";
import AdminViewLeads from "./Components/Pages/Admin/Leads/ViewLeads/ViewLeads";
import AdminOpportunity from "./Components/Pages/Admin/Potentialleads/Potentialleads";



import CreateCustomerOpportunity from "./Components/Pages/Sales-Executive/Leads/ViewLeads/CreateCustomerOpportinity/CreateandOpportunity";
import CommentsPage from "./Components/Pages/Sales-Executive/Leads/ViewLeads/Comment/CommentsPage";
import EditOppLead from './Components/Pages/Sales-Executive/Potentialleads/EditOpp/EditOppLead';
import EditLead from './Components/Pages/Sales-Executive/Leads/ViewLeads/EditLead/EditLead';
import Webhook from './Webhook';
import InDetailViewLeads from "./Components/Pages/Sales-Executive/Leads/ViewLeads/ViewLead/InDetailViewLeads";
import LeadDetailss from "./Components/Pages/Sales-Executive/Potentialleads/LeadDetails";
import M_EditLead from "./Components/Pages/Manager/Leads/ViewLeads/EditLead/EditLead";
import M_InDetailViewLeads from "./Components/Pages/Manager/Leads/ViewLeads/ViewLead/InDetailViewLeads";
import M_CommentsPage from "./Components/Pages/Manager/Leads/ViewLeads/Comment/CommentsPage";
import M_EditOppLead from "./Components/Pages/Manager/Potentialleads/EditOpp/EditOppLead";
import M_LeadDetailss from "./Components/Pages/Manager/Potentialleads/LeadDetails";
import M_CreateCustomerOpportunity from "./Components/Pages/Manager/Leads/ViewLeads/CreateCustomerOpportinity/CreateandOpportunity";
import A_EditLead from "./Components/Pages/Admin/Leads/ViewLeads/EditLead/EditLead";
import A_InDetailViewLeads from "./Components/Pages/Admin/Leads/ViewLeads/ViewLead/InDetailViewLeads";
import A_CommentsPage from "./Components/Pages/Admin/Leads/ViewLeads/Comment/CommentsPage";
import A_EditOppLead from "./Components/Pages/Admin/Potentialleads/EditOpp/EditOppLead";
import A_LeadDetailss from "./Components/Pages/Admin/Potentialleads/LeadDetails";
import A_CreateCustomerOpportunity from "./Components/Pages/Admin/Leads/ViewLeads/CreateCustomerOpportinity/CreateandOpportunity";
import AddEmployeeModal from "./Components/Pages/Admin/AllTeams/AddEmployeeModal";
import A_Addleads from "./Components/Pages/Admin/Leads/AddLeads/Addleads";
import Manager_Addleads from "./Components/Pages/Manager/Leads/AddLeads/Addleads";
import S_Allleads from "./Components/Pages/Sales-Executive/Allleads/Alllead";
import MyTeamSales from "./Components/Pages/Sales-Executive/MyTeam/MyTeamSales";
import Customerdetails from "./Components/Pages/Sales-Executive/Customer/LeadOptions";
import A_Customerdetails from "./Components/Pages/Admin/Customer/LeadOptions";
import M_Customerdetails from "./Components/Pages/Manager/Customer/LeadOptions";
import TeamMembers from "./Components/Pages/Admin/AllTeams/TeamMembersTable";
import EditCustomer from "./Components/Pages/Sales-Executive/Customer/Editcustomer";
import M_EditCustomer from "./Components/Pages/Manager/Customer/Editcustomer";
import A_EditCustomer from "./Components/Pages/Admin/Customer/Editcustomer";
import ProtectedRoute from "./Components/Pages/ProtectedRoute/ProtectedRoute"; 
import A_Profile from "./Components/Pages/Admin/Profile/Profile";
import M_Profile from "./Components/Pages/Manager/Profile/Profile";
import Addonboarding from "./Components/Pages/Admin/Onboarding/AddEmployeeModal";
import Viewonboarding from "./Components/Pages/Admin/Onboarding/AllTeams";
import ViewonboardingId from "./Components/Pages/Admin/Onboarding/TeamMembersTable";
import Mobile from "./Mobile";
import EditEmployee from "./Components/Pages/Admin/AllTeams/EditEmployee/EditEmployee";
import M_Allleads from "./Components/Pages/Manager/Allleads/Alllead";

import Tabelfilter from "./Tabelfilter";
import M_viewallleads from "./Components/Pages/Manager/Viewallleads/InDetailViewLeads";
import S_viewallleads from "./Components/Pages/Sales-Executive/Viewallleads/InDetailViewLeads";
import Destinations from "./Components/Pages/Admin/Destinations/Destinations";

import Archive from "./Components/Pages/Admin/Archieve/Archive";
import Email from "./Components/Pages/Admin/Potentialleads/Email/Email";
import A_myopp from "./Components/Pages/Admin/Leads/Myleads/Myleads";
import A_MyOpplead from "./Components/Pages/Admin/Potentialleads/MyOpp/Myopp";
import A_MyLeadDetailss from "./Components/Pages/Admin/Potentialleads/MyOppView";
import A_MyCreateCustomerOpportunity from "./Components/Pages/Admin/Leads/MyCreateCustomerOpportinity/CreateandOpportunity";
import NotFound from "./Components/Shared/NotFound/NotFound";
import EmailChat from "./Email";
import Tags from "./Components/Pages/Admin/Tags/Tag";
import ThemeProvider from "./Components/Shared/Themes/ThemeContext";
import { FontSizeProvider } from "./Components/Shared/Font/FontContext";
import Themes from "./Components/Shared/Themes/Themes";
import M_Myoppleads from "./Components/Pages/Manager/Potentialleads/MyOpp/MyOpplead";
import M_Myleads from "./Components/Pages/Manager/Leads/Myleads/Myleads";
import M_MYCreateCustomerOpportunity from "./Components/Pages/Manager/Leads/Myleads/CreateCustomerOpportinity/CreateandOpportunity"
import EmailHistory from "./Components/Pages/Admin/Potentialleads/Email/Email_new";
import H_Dashboard from "./Components/Pages/SalesHead/Dashboard/Dashboard";
import H_ViewLeads from "./Components/Pages/SalesHead/Leads/ViewLeads/ViewLeads";
import HeadOpportunity from "./Components/Pages/SalesHead/Potentialleads/Potentialleads";
import H_Customer from "./Components/Pages/SalesHead/Customer/Customer";
import H_Destinations from "./Components/Pages/SalesHead/Destinations/Destinations";
import H_Tags from "./Components/Pages/SalesHead/Tags/Tag";
import H_AllTeams from "./Components/Pages/SalesHead/AllTeams/AllTeams";
import H_TeamMembers from "./Components/Pages/SalesHead/AllTeams/TeamMembersTable";
import H_Customerdetails from "./Components/Pages/SalesHead/Customer/LeadOptions";
import H_LeadDetailss from "./Components/Pages/SalesHead/Potentialleads/LeadDetails";
import H_InDetailViewLeads from "./Components/Pages/SalesHead/Leads/ViewLeads/ViewLead/InDetailViewLeads";
import H_Profile from "./Components/Pages/SalesHead/Profile/Profile";
import M_EmailHistory from "./Components/Pages/Manager/Potentialleads/Email/Email_new";
import S_EmailHistory from "./Components/Pages/Sales-Executive/Potentialleads/Email/Email_new";
import AdminSupplier from "./Components/Pages/Admin/Suppliers/AdminSupplier";
import AddSupplier from "./Components/Pages/Admin/Suppliers/AddSupplier";
import PaymentsPage from "./Components/Pages/Admin/Payments/PaymentsPage";
import AddPaymentPage from "./Components/Pages/Admin/Payments/PaymentForm";
import SupplierTable from "./Components/Pages/Admin/Payments/Suppliers/Supplier";
import PaymentPage from "./Components/Pages/Admin/Payments/Suppliers/PaymentPage";
import HistoryPage from "./Components/Pages/Admin/Payments/Suppliers/HistoryPage";
import SupplierForm from "./Components/Pages/Admin/Payments/Suppliers/SupplierForm";
import M_SupplierTable from "./Components/Pages/Manager/Payments/Suppliers/Supplier";
import M_PaymentsPage from "./Components/Pages/Manager/Payments/PaymentsPage";
import M_SupplierForm from "./Components/Pages/Manager/Payments/Suppliers/SupplierForm";
import M_PaymentPage from "./Components/Pages/Manager/Payments/Suppliers/PaymentPage";
import M_HistoryPage from "./Components/Pages/Manager/Payments/Suppliers/HistoryPage";
import M_AddPaymentPage from "./Components/Pages/Manager/Payments/PaymentForm";
import A_Report from "./Components/Pages/Admin/Report/Report";

import A_Report_opp from "./Components/Pages/Admin/Report/OppReport";
import A_Report_customer from "./Components/Pages/Admin/Report/Customer";
import S_SupplierTable from "./Components/Pages/Sales-Executive/Payments/Suppliers/Supplier";
import S_PaymentsPage from "./Components/Pages/Sales-Executive/Payments/PaymentsPage";
import S_SupplierForm from "./Components/Pages/Sales-Executive/Payments/Suppliers/SupplierForm";
import S_PaymentPage from "./Components/Pages/Sales-Executive/Payments/Suppliers/PaymentPage";
import S_HistoryPage from "./Components/Pages/Sales-Executive/Payments/Suppliers/HistoryPage";
import S_AddPaymentPage from "./Components/Pages/Sales-Executive/Payments/PaymentForm";

import M_MySupplierTable from "./Components/Pages/Manager/MyPayments/Suppliers/MySupplier";
import M_MyPaymentsPage from "./Components/Pages/Manager/MyPayments/MyPaymentsPage";
import M_MySupplierForm from "./Components/Pages/Manager/MyPayments/Suppliers/MySupplierForm";
import M_MyPaymentPage from "./Components/Pages/Manager/MyPayments/Suppliers/MyPaymentPage";
import M_MyHistoryPage from "./Components/Pages/Manager/MyPayments/Suppliers/MyHistoryPage";
import M_MyAddPaymentPage from "./Components/Pages/Manager/MyPayments/MyPaymentForm";
import MySupplierTable from "./Components/Pages/Admin/MyPayments/Suppliers/MySupplier";
import MyPaymentsPage from "./Components/Pages/Admin/MyPayments/MyPaymentsPage";
import MySupplierForm from "./Components/Pages/Admin/MyPayments/Suppliers/MySupplierForm";
import MyPaymentPage from "./Components/Pages/Admin/MyPayments/Suppliers/MyPaymentPage";
import MyHistoryPage from "./Components/Pages/Admin/MyPayments/Suppliers/MyHistoryPage";
import MyAddPaymentPage from "./Components/Pages/Admin/MyPayments/MyPaymentForm";
import A_emailcredentials from "./Components/Pages/Admin/Emailcredentials/Credential_form";



import M_Report from "./Components/Pages/Manager/Report/Report";

import M_Report_opp from "./Components/Pages/Manager/Report/OppReport";
import M_Report_customer from "./Components/Pages/Manager/Report/Customer";
import S_Report from "./Components/Pages/Sales-Executive/Report/Report";

import S_Report_opp from "./Components/Pages/Sales-Executive/Report/OppReport";
import S_Report_customer from "./Components/Pages/Sales-Executive/Report/Customer";




//
import M_LeadsCommentsPage from "./Components/Pages/Manager/Leads/ViewLeads/Comment/LeadsComments";
import S_CommentsPage from "./Components/Pages/Sales-Executive/Leads/ViewLeads/Comment/LeadsComments";
import A_LeadsCommentsPage from "./Components/Pages/Admin/Leads/ViewLeads/Comment/LeadsComments";
import M_MyEmailHistory from "./Components/Pages/Manager/Potentialleads/Email/My_Email";
import M_MyCommentsPage from "./Components/Pages/Manager/Leads/ViewLeads/Comment/MyCommentsPage";
import My_CommentsPage from "./Components/Pages/Admin/Leads/ViewLeads/Comment/My_CommentsPage";
import My_EmailHistory from "./Components/Pages/Admin/Potentialleads/Email/My_Email";
import A_PaymentApprovals from "./Components/Pages/Admin/Approvals/Payment_Approvals";
import SupplierApproval from "./Components/Pages/Admin/Approvals/SupplierPayments";
import EditSuppayment from "./Components/Pages/Sales-Executive/Payments/Suppliers/EditSuppayment";


import M_EditSuppayment from "./Components/Pages/Manager/Payments/Suppliers/EditSupPayment";
import M_MyEditSuppayment from "./Components/Pages/Manager/MyPayments/Suppliers/EditSupPayment";
import A_EditSuppayment from "./Components/Pages/Admin/Payments/Suppliers/EditSupPayment";
import A_MyEditSuppayment from "./Components/Pages/Admin/MyPayments/Suppliers/EditSupPayment";

import EditReceivable from "./Components/Pages/Admin/Approvals/EditReceivable";
import EditSupPayment from "./Components/Pages/Admin/Approvals/EditSupPayment";
import Admin_editsupplier from "./Components/Pages/Admin/Suppliers/EditSupplierlist";



import A_emailtable from "./Components/Pages/Admin/Emailcredentials/Credentialstable";
import ReportComments from "./Components/Pages/Admin/Report/ReportComments";
import LeadStatus from "./Components/Pages/Admin/LeadStatus/LeadStatus";
import OpportunityStatus from "./Components/Pages/Admin/LeadStatus/OpportunityStatus";
import ReminderAlert from "./Components/Pages/Admin/Potentialleads/ReminderAlert";
import CommentsModalpop from "./Components/Pages/Admin/Leads/ViewLeads/CommentsModalPop/CommentsModalpop";
import CommentsModalPopmangaer from "./Components/Pages/Admin/Leads/ViewLeads/CommentsModalPop/CommentsModalPopmangaer";
import CommentsModalpopemployee from "./Components/Pages/Admin/Leads/ViewLeads/CommentsModalPop/CommentsModalpopemployee";
import Reminderactions from "./Components/Pages/Admin/Potentialleads/Reminderactions";

import Templates from "./Components/Pages/Admin/WhatsappTemplates/Templates";
import OppTemplates from "./Components/Pages/Admin/WhatsappTemplates/OppTemplates";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,  // 10 minutes cache
      cacheTime: 1000 * 60 * 30, // keep in memory 30 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
    return (
         <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <ThemeProvider>
            <FontSizeProvider>
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<LoginNew />} />
                <Route path="/forgot" element={<Forgot />} />


                
                <Route element={<ProtectedRoute />}>
                <Route path="/add-lead" element={<Addleads />} />
                <Route path="/view-lead" element={<ViewLeads />} />
                
              
            
               
                <Route path="/m-dashboard" element={<ManagerDashboard />} />
                <Route path="/s-dashboard" element={<SalesDashboard />} />
                <Route path="/dashboard" element={<AdminDashboard />} />
               
                <Route path="/m-customers" element={<ManagerCustomer />} />
                <Route path="/a-customers" element={<AdminCustomer />} />
                <Route path="/s-customers" element={<SalesCustomer />} />
                
               
                <Route path="/m-myteam" element={<MyTeam />} />
                <Route path="/potential-leads" element={<Potentialleads />} />
                <Route path="/potential-leads/:leadId?" element={<LeadDetails />} />
                <Route path="/m-potential-leads" element={<ManagerPotentialLeads />} />
                <Route path="/m-potential-leads/:leadId?" element={<ManagerLeadDetails />} />
                <Route path="/m-add-leads" element={<ManagerAddleads />} />
                <Route path="/m-view-leads" element={<ManagerViewLeads />} />
                <Route path="/profile" element={<ProfileForm />} />
                <Route path="/m-profile" element={<M_Profile />} />
                <Route path="/a-profile" element={<A_Profile />} />
                {/* <Route path="/a-service" element={<Service />} /> */}
                <Route path="/a-allteams" element={<AllTeams />} />
                <Route path="/a-view-lead" element={<AdminViewLeads />} />
                <Route path="/a-potential-leads" element={<AdminOpportunity />} />
            
              
               
               
                <Route path="/create-customer-opportunity/:leadid" element={<CreateCustomerOpportunity />} />
                <Route path="/comments/:leadid" element={<S_CommentsPage />} />
                <Route path="/edit-lead/:leadid" element={<EditLead />} />
                <Route path="/edit-opportunity/:leadid" element={<EditOppLead />} />
                <Route path="/view-lead/:leadid" element={<InDetailViewLeads />} />
                <Route path="/webhook" element={<Webhook />} />
                <Route path="/details/:leadid" element={<LeadDetailss />} />



                <Route path="/m-edit-lead/:leadid" element={<M_EditLead />} />
                <Route path="/m-view-lead/:leadid" element={<M_InDetailViewLeads />} />
                <Route path="/m-comments/:leadid" element={<M_LeadsCommentsPage />} />
                <Route path="/m-edit-opportunity/:leadid" element={<M_EditOppLead />} />
                <Route path="/m-details/:leadid" element={<M_LeadDetailss />} />
                <Route path="/m-create-customer-opportunity/:leadid" element={<M_CreateCustomerOpportunity />} />



                <Route path="/a-edit-lead/:leadid" element={<A_EditLead />} />
                <Route path="/a-view-lead/:leadid" element={<A_InDetailViewLeads />} />
                <Route path="/a-comments/:leadid" element={<A_LeadsCommentsPage />} />
                <Route path="/a-edit-opportunity/:leadid" element={<A_EditOppLead />} />
                <Route path="/a-details/:leadid" element={<A_LeadDetailss />} />
                <Route path="/a-create-customer-opportunity/:leadid" element={<A_CreateCustomerOpportunity />} />
                <Route path="/addemployee" element={<AddEmployeeModal />} />


                <Route path="/a-add-leads" element={<A_Addleads/>} />
                <Route path="/m-add-leads" element={<Manager_Addleads />} />



                <Route path="/sales-details/:leadid" element={<LeadDetailss />} />
                <Route path="/opportunity-comments/:leadid" element={<CommentsPage />} />



                <Route path="/s-allleads" element={<S_Allleads />} />
                
                <Route path="/s-myteam" element={<MyTeamSales />} />




                <Route path="/m-customer-details/:leadid" element={<M_LeadDetailss />} />
                <Route path="/m-opportunity-comments/:leadid" element={<M_CommentsPage />} />
              <Route path="/a-customer-details/:leadid" element={<A_LeadDetailss />} />
                <Route path="/a-opportunity-comments/:leadid" element={<A_CommentsPage />} />


                <Route path="/customerdetails/:customerId" element={<Customerdetails />} />
                <Route path="/m-customerdetails/:customerId" element={<M_Customerdetails />} />
                <Route path="/a-customerdetails/:customerId" element={<A_Customerdetails />} />



                <Route path="/s-view-lead/:leadid" element={<InDetailViewLeads />} />

                <Route path="/team-members" element={<TeamMembers />} />

                <Route path="/editcustomerdetails/:customerId" element={<EditCustomer />} />
                <Route path="/a-editcustomerdetails/:customerId" element={<A_EditCustomer />} />
                <Route path="/m-editcustomerdetails/:customerId" element={<M_EditCustomer />} />




                //extra
                <Route path="/a-onboarding" element={<Addonboarding />} />
                <Route path="/a-viewonboarding" element={<Viewonboarding />} />
                <Route path="/a-viewonboarding/:id" element={<ViewonboardingId />} />


                <Route path="/editemployee/:id" element={<EditEmployee />} />
                <Route path="/mobile" element={<Mobile />} />




                <Route path="/m-allleads" element={<M_Allleads />} />
                <Route path="/m-views-lead/:leadid" element={<M_InDetailViewLeads />} />


                <Route path="/tablefilter" element={<Tabelfilter />} />


                <Route path="/m-viewallleads/:leadid" element={<M_viewallleads />} />
                <Route path="/s-viewallleads/:leadid" element={<S_viewallleads />} />



                //comments
                <Route path="/comments/:leadid" element={<CommentsPage />} />
                <Route path="/m-comments/:leadid" element={<M_CommentsPage />} />
                <Route path="/a-comments/:leadid" element={<A_CommentsPage />} />

                <Route path="/a-destinations" element={<Destinations />} />


                <Route path="/a-archivedata" element={<Archive />} />



                <Route path="/a-email/:leadId" element={<Email />} />






                <Route path="/a-myleads" element={<A_myopp />} />
                <Route path="/a-myview-lead/:leadid" element={<A_InDetailViewLeads />} />
                <Route path="/a-myedit-lead/:leadid" element={<A_EditLead />} />
                <Route path="/a-mycreate-customer-opportunity/:leadid" element={<A_MyCreateCustomerOpportunity />} />
                <Route path="/a-mycomments/:leadid" element={<A_LeadsCommentsPage />} />




                <Route path="/a-myopp" element={<A_MyOpplead />} />
                <Route path="/a-myedit-opportunity/:leadid" element={<A_EditOppLead />} />
                <Route path="/a-mydetails/:leadid" element={<A_MyLeadDetailss />} />

                
                <Route path="/a-myopportunity-comments/:leadid" element={<My_CommentsPage />} />



                <Route path="*" element={<NotFound />} />



                <Route path="/emailchat" element={<EmailChat />} />

                <Route path="/a-tags" element={<Tags/>} />
                 <Route path="/a-whatsapp-templates" element={<Templates/>} />
                   <Route path="/a-opp-whatsapp-templates" element={<OppTemplates/>} />
                 <Route path="/a-lead-status" element={<LeadStatus/>} />
                  <Route path="/a-lead-opp-status" element={<OpportunityStatus />} />
                <Route path="/themes" element={<Themes />} />

                <Route path="/admin-supplierlist" element={<AdminSupplier />} />
                <Route path="/admin-add-supplier" element={<AddSupplier />} />
                 <Route path="/a-supplier/:leadid" element={<SupplierTable />} /> 
                <Route path="/a-payments/:leadid" element={<PaymentsPage />} />  
                <Route path="/a-add-supplier/:leadid" element={<SupplierForm />} />      
                <Route path="/a-suppliers/:supplierId/:leadid" element={<PaymentPage />} />
                <Route path="/a-suppliers/:supplierId/history" element={<HistoryPage />} />
                <Route path="/a-add-payment/:leadid" element={<AddPaymentPage />} />
                <Route path="/a-mysupplier/:leadid" element={<MySupplierTable />} /> 
                <Route path="/a-mypayments/:leadid" element={<MyPaymentsPage />} />  
                <Route path="/a-add-mysupplier/:leadid" element={<MySupplierForm />} />      
                <Route path="/a-mysuppliers/:supplierId/:leadid" element={<MyPaymentPage />} />
                <Route path="/a-mysuppliers/:supplierId/history" element={<MyHistoryPage />} />
                <Route path="/a-add-mypayment/:leadid" element={<MyAddPaymentPage />} />
                <Route path="/m-mysupplier/:leadid" element={<M_MySupplierTable />} /> 
                <Route path="/m-add-mysupplier/:leadid" element={<M_MySupplierForm />} />      
                <Route path="/m-mysuppliers/:supplierId/:leadid" element={<M_MyPaymentPage />} />
                <Route path="/m-mysuppliers/:supplierId/history" element={<M_MyHistoryPage />} />
                <Route path="/m-add-mypayment/:leadid" element={<M_MyAddPaymentPage />} />
                <Route path="/m-mypayments/:leadid" element={<M_MyPaymentsPage />} /> 
                

                <Route path="/s-supplier/:leadid" element={<S_SupplierTable />} /> 
                <Route path="/s-payments/:leadid" element={<S_PaymentsPage />} />  
                <Route path="/s-add-supplier/:leadid" element={<S_SupplierForm />} />      
                <Route path="/s-suppliers/:supplierId/:leadid" element={<S_PaymentPage />} />
                <Route path="/s-suppliers/:supplierId/history" element={<S_HistoryPage />} />
                <Route path="/s-add-payment/:leadid" element={<S_AddPaymentPage />} />

                <Route path="/m-edit-payment/:leadid/:paymentid" element={<M_AddPaymentPage />} />
                <Route path="/m-edit-mypayment/:leadid/:paymentid" element={<M_MyAddPaymentPage />} />
                <Route path="/s-edit-payment/:leadid/:paymentid" element={<S_AddPaymentPage />} />

                <Route path="/a-edit-payment/:leadid/:paymentid" element={<AddPaymentPage />} />
                <Route path="/a-edit-mypayment/:leadid/:paymentid" element={<MyAddPaymentPage />} />


                <Route path="/m-supplier/:leadid" element={<M_SupplierTable />} /> 
                <Route path="/m-payments/:leadid" element={<M_PaymentsPage />} />  
                <Route path="/m-add-supplier/:leadid" element={<M_SupplierForm />} />      
                <Route path="/m-suppliers/:supplierId/:leadid" element={<M_PaymentPage />} />
                <Route path="/m-suppliers/:supplierId/history" element={<M_HistoryPage />} />
                <Route path="/m-add-payment/:leadid" element={<M_AddPaymentPage />} />
                


                <Route path="/m-myoppleads" element={<M_Myoppleads/>} />
                <Route path="/m-myleads" element={<M_Myleads/>} />



                <Route path="/m-myedit-lead/:leadid" element={<M_EditLead />} />
                <Route path="/m-myview-lead/:leadid" element={<M_InDetailViewLeads />} />
                <Route path="/m-mycomments/:leadid" element={<M_LeadsCommentsPage />} />
                <Route path="/m-myedit-opportunity/:leadid" element={<M_EditOppLead />} />
                <Route path="/m-mydetails/:leadid" element={<M_LeadDetailss />} />
                <Route path="/m-mycreate-customer-opportunity/:leadid" element={<M_MYCreateCustomerOpportunity />} />
                <Route path="/m-myopportunity-comments/:leadid" element={<M_MyCommentsPage />} />
                {/* <Route path="/email-history" element={<EmailHistory />} /> */}
                

                <Route path="/email-history/:leadid" element={<EmailHistory />} />
                <Route path="/a_myemail-history/:leadid" element={<My_EmailHistory />} />

                <Route path="h-dashboard" element={<H_Dashboard />} />
                <Route path="/h-view-lead" element={<H_ViewLeads />} />
                <Route path="/h-potential-leads" element={<HeadOpportunity />} />
                <Route path="/h-customers" element={<H_Customer />} />
                <Route path="/h-destinations" element={<H_Destinations />} />
                <Route path="/h-tags" element={<H_Tags/>} />
                <Route path="/h-allteams" element={<H_AllTeams />} />
                <Route path="/h-team-members" element={<H_TeamMembers />} />
                <Route path="/h-customerdetails/:customerId" element={<H_Customerdetails />} />
                <Route path="/h-details/:leadid" element={<H_LeadDetailss />} />
                <Route path="/h-view-lead/:leadid" element={<H_InDetailViewLeads />} />
                <Route path="/h-profile" element={<H_Profile />} />




                <Route path="/m_email-history/:leadid" element={<M_EmailHistory />} />
                <Route path="/m_myemail-history/:leadid" element={<M_MyEmailHistory />} />
                <Route path="/s_email-history/:leadid" element={<S_EmailHistory />} />


                <Route path="/A_Report" element={<A_Report />} />

                <Route path="/A_Report_opp" element={<A_Report_opp />} />
                <Route path="/A_Report_customer" element={<A_Report_customer />} />



                <Route path="/A_emailcredentials" element={<A_emailcredentials />} />
                <Route path="/A_table_emailcredentials" element={<A_emailtable />} />
                <Route path="/A_edit-credentials/:id" element={<A_emailcredentials />} />



          

                <Route path="/M_Report" element={<M_Report />} />

                <Route path="/M_Report_opp" element={<M_Report_opp />} />
                <Route path="/M_Report_customer" element={<M_Report_customer />} />
                <Route path="/S_Report" element={<S_Report />} />

                <Route path="/S_Report_opp" element={<S_Report_opp />} />
                <Route path="/S_Report_customer" element={<S_Report_customer />} />


                <Route path="/a-approvals" element={<A_PaymentApprovals />} />
                <Route path="/a-approval-supplier" element={<SupplierApproval />} />

                <Route path="/s-edit-suppayment/:paymentId" element={<EditSuppayment />} />




                <Route path="/s-edit-suppayment/:paymentId" element={<EditSuppayment />} />
                <Route path="/m-edit-suppayment/:paymentId" element={<M_EditSuppayment />} />
                <Route path="/a-edit-suppayment/:paymentId" element={<A_EditSuppayment />} />

                <Route path="/m-edit-mysuppayment/:paymentId" element={<M_MyEditSuppayment />} />
                <Route path="/a-edit-mysuppayment/:paymentId" element={<A_MyEditSuppayment />} />
                <Route path="/a-edit-approval-payment/:leadid/:paymentid" element={<EditReceivable />} />
                <Route path="/a-edit-sup-approval-payment/:paymentId" element={<EditSupPayment />} />

                <Route path="/admin-edit-supplier/:id" element={<Admin_editsupplier />} />
<Route path="/comments-report/:leadid" element={<ReportComments />} />
<Route path="/cronalert" element={<ReminderAlert />} />

<Route path="/comments-admin/:leadid" element={<CommentsModalpop />} />
<Route path="/comments-manager/:leadid" element={<CommentsModalPopmangaer />} />
<Route path="/comments-employee/:leadid" element={<CommentsModalpopemployee />} />
<Route path="/reminderactions/:leadid" element={<Reminderactions />} />
<Route path="/reminderactions" element={<Reminderactions />} />

                </Route>
            </Routes>

         
 
        </Router>
        </FontSizeProvider>
        </ThemeProvider>
        </AuthProvider>
        </QueryClientProvider>
    );
}

export default App;


